/* eslint-disable */
import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import 'contents/assets/scss/page/teacher.scss';
import Tab from '../../../component/Inc/Tab';
import DetailTab1 from './DetailTab1';
import DetailTab2 from './DetailTab2';
import DetailTab3 from './DetailTab3';
import DetailTab4 from './DetailTab4';
function TeacherCampaignDetail() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '1. 종합평가 부문', value: 0},
    {title: '2. 화상 종합평가 부문', value: 1},
    {title: '3. 개인 인센티브 부문', value: 2},
    {title: '4. 영역별 인센티브 배정 관리자 평가 부분', value: 3}
  ];
  return (
    <main className="com_container p_campaign">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu2_10">
            실적관리 캠페인<span className="bar"></span>
            <span className="point_txt">2023, 05, 10 ~ 2023, 05, 12 (진행중) </span>
          </h2>
          <div className="com_btn_wrap">
            <Link to="/Teacher/Campaign/Create" className="com_btn orange s btn_plus">
              캠페인 만들기
            </Link>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
            </div>
          </section>
          {tabIdx === 0 && <DetailTab1 />}
          {tabIdx === 1 && <DetailTab2 />}
          {tabIdx === 2 && <DetailTab3 />}
          {tabIdx === 3 && <DetailTab4 />}
        </section>
      </div>
    </main>
  );
}

export default TeacherCampaignDetail;
